@if (data.discount) {
  <span class="full-price">{{ fullPrice | currency: 'SEK' }}</span>
  <span class="discount-price">{{ data.price | currency: 'SEK' }}</span>
} @else if (data.price) {
  {{ data.price | currency: 'SEK' }}
} @else {
  -
}
